import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DragHandleDots2Icon, TrashIcon } from '@radix-ui/react-icons'
import { Flex, IconButton, Separator, Text } from '@radix-ui/themes'
import { useState } from 'react'
import { SearchResult } from '@Generated/back-office-client/src'

type PinnedResultProps = SearchResult & {
  onRemove: () => void
}

export const PinnedResult = ({ id, resultType, name, onRemove }: PinnedResultProps) => {
  const [hovered, setHovered] = useState(false)
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition } =
    useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Flex
      className="pinned-result"
      ref={setNodeRef}
      style={style}
      {...attributes}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}>
      <Flex>
        <Flex ref={setActivatorNodeRef} className="pinned-result__drag-handle" {...listeners}>
          <DragHandleDots2Icon />
        </Flex>
        <Flex direction="column" className="pinned-result__labels">
          <Text>name</Text>
          <Text>result_type</Text>
          <Text>id</Text>
        </Flex>
      </Flex>

      <Separator orientation="vertical" size="4" className="pinned-result__separator" />

      <Flex justify="between" width="100%">
        <Flex direction="column">
          <Text>{name}</Text>
          <Text>{resultType}</Text>
          <Text>{id}</Text>
        </Flex>

        {hovered ? (
          <Flex align="center">
            <IconButton variant="ghost" className="remove-pinned-result" onClick={onRemove}>
              <TrashIcon />
            </IconButton>
          </Flex>
        ) : null}
      </Flex>
    </Flex>
  )
}
